var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 6,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.983 5.851a.22.22 0 0 1-.2.149H.217a.22.22 0 0 1-.2-.149.27.27 0 0 1 .045-.265L4.844.074A.2.2 0 0 1 5 0c.059 0 .115.027.156.074l4.782 5.512c.061.07.079.175.045.265"
})));
export default SvgArrowUp;